<h1 mat-dialog-title>{{ "reopen.header" | translate }}</h1>
<mat-dialog-content>
  <h3>{{ "reopen.Message" | translate }}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-flat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button class="ms-2" color="primary" (click)="onOpen()">
      {{ "reopen.Open" | translate }}
    </button>
  </div>
</mat-dialog-actions>
